import React, { useState } from 'react';
import { MapPin, ChevronDown, ChevronUp } from 'lucide-react';

const RouteCard = ({ route, isExpanded, onToggle }) => {
  return (
    <div className="route-detailed-card">
      <div className="route-card-header">
        <div className="route-icon">
          <MapPin size={32} />
        </div>
        <span className="route-trains">{route.trains}</span>
      </div>
      <h3>{route.title}</h3>
      <p className="route-path-large">{route.route}</p>
      <p className="route-description">{route.description}</p>
      
      <button 
        className="view-stations-btn"
        onClick={onToggle}
      >
        {isExpanded ? (
          <>
            <span>Hide Stations</span>
            <ChevronUp size={20} />
          </>
        ) : (
          <>
            <span>View All {route.stations.length} Stations</span>
            <ChevronDown size={20} />
          </>
        )}
      </button>

      {isExpanded && (
        <div className="stations-list">
          <div className="stations-header">
            <span>Station</span>
            <span>Code</span>
            <span>Type</span>
          </div>
          {route.stations.map((station) => (
            <div key={station.code} className="station-item">
              <span className="station-name">{station.name}</span>
              <span className="station-code">{station.code}</span>
              <span className="station-type">{station.type}</span>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default RouteCard;
